import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=0a2a480f&scoped=true&"
var script = {}
import style0 from "./Welcome.vue?vue&type=style&index=0&id=0a2a480f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2a480f",
  null
  
)

export default component.exports